import { Is1TimeGoal } from '../services/Log/ValidateEntry/Validations/Is1TimeGoal';

export function GetKipsBasedOnGoalType(entryText: string) {
	const enteredValue = ExtractValue(entryText);

	if (ValueIsInvalid(enteredValue)) {
		return 0;
	}

	if (Is1TimeGoal(entryText)) {
		return 10;
	}

	return enteredValue;
}

const ExtractValue = (entryText: string) => parseInt(entryText.split(' ')[1]);

const ValueIsInvalid = (goalValue: number) => !(goalValue > 0);
